interface ATCAppConfigType {
	POST_ATC_DETAILS_URL: string;
	GET_ATC_DETAILS_URL: string;
	GET_ATC_LICENSING_CODE_URL: string;
	ATC_DELETE: string;
	PUT_TC_FILE: string;
	ATC_PREVIEW: string;
	ATC_PREVIEW_DOWNLOAD:string;
	ATC_DATA_PREVIEW: string;
    POST_ATC_PUBLIC: string;
	GET_DTRACKIT_REF_CODE: string;
	GET_CBLICENSING_CODE: string;
	GET_COUNTRY_CODE: string;
	GET_STATE_CODE: string;
	GET_RAW_MATERIAL_CODE: string;
	GET_PRODUCT_CODE: string;
	GET_PRODUCT_DETAIL_CODE: string;
  }
  
  const TE_TYPES: any = {
	ATC: "v1/ml",
  };
  
  export const ATCAppConfig: ATCAppConfigType = {
	POST_ATC_DETAILS_URL: `${TE_TYPES.ATC}/post-atc-details`,
	GET_ATC_DETAILS_URL: `${TE_TYPES.ATC}/get-atc-details`,
	GET_ATC_LICENSING_CODE_URL: `${TE_TYPES.ATC}/get-atc-licensingcode`,
	ATC_DELETE: `${TE_TYPES.ATC}/invalidate-atc`,
	PUT_TC_FILE: `${TE_TYPES.ATC}/upload-file-atc`,
	ATC_PREVIEW: `${TE_TYPES.ATC}/get-file-atc`,
	ATC_PREVIEW_DOWNLOAD: `${TE_TYPES.ATC}/download-file-atc`,
	ATC_DATA_PREVIEW: `${TE_TYPES.ATC}/get-atc-preview`,
	POST_ATC_PUBLIC: `${TE_TYPES.ATC}/post-atc`,
	GET_DTRACKIT_REF_CODE: `${TE_TYPES.ATC}/get-dtrackit-ref-code`,
	GET_CBLICENSING_CODE: "CXF",
	GET_COUNTRY_CODE: "CT",
	GET_STATE_CODE: "ST",
	GET_RAW_MATERIAL_CODE: "RM",
	GET_PRODUCT_CODE: "PD",
	GET_PRODUCT_DETAIL_CODE: "PDD",
  };
  
 
  
  export default ATCAppConfig;
  


